/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

import { LifecycleCard, LifecycleList } from "@/components/lifecycle";
import { TimeReport } from "@/data/time-reports";
import { useTimeReportLifecycleQuery } from "@/data/time-reports/queries/useTimeReportLifecycleQuery";

interface TimeReportDetailsLifecycleTabProps {
  timeReport: TimeReport;
}

export const TimeReportDetailsLifecycleTab: FC<TimeReportDetailsLifecycleTabProps> = ({ timeReport }) => {
  const { data } = useTimeReportLifecycleQuery(timeReport.guid);

  return (
    <LifecycleList actions={data.content}>
      {timeReport.creationDate && (
        <LifecycleCard
          action={{
            actionPerformed: { code: "CREATE" },
            attachments: null,
            comment: null,
            externalComment: null,
            completionDate: timeReport.creationDate,
          }}
        />
      )}
    </LifecycleList>
  );
};
